import React, { useContext, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  Button,
  Layout,
  MobileTabBar,
  Footer,
  Accordion,
  Input,
  Select,
  SelectFile,
} from '../../components';

import './support.less';
import '../Profile/profile-general.less';
import '../../components/Card/card.less';

import RightChevronIcon from '../../assests/icons/right-chevron.icon';
import { Tabs, Modal, Form } from 'antd';
import { DimensionsContext } from '../../context/dimensions.context';
import UploadIcon from '../../assests/icons/upload.icon';
import ContactUs from 'components/ContactUs/contactus';

const { TabPane } = Tabs;

const AccordionList = [
  {
    header: 'Hangi ödeme yöntemleriyle paket alabilirim?',
    content:
      'Kredi kartı, banka kartı, faturama yansıt veya öde ve kullan ile paket satın alabilirsiniz.​',
  },
  {
    header: 'Öde ve Kullan Nedir?',
    content:
      "Öde ve Kullan yöntemi ile dilediğiniz Mesaj Üssü paketi için sanal bir fatura oluşturabilir ve bu faturayı herhangi Turkcell faturası öder gibi ödeyebilirsiniz.Ödeme bilgisi Turkcell'e ulaştığında satın almış olduğunuz Mesaj Üssü paketi hesabınıza yüklenecektir. Satın almak istediğiniz Mesaj Üssü paketi için Turkcell faturanıza yansıtma limitinizin yeterli olmaması ve kredi kartı ile satın alım yapmak istememeniz durumunda Öde ve Kullan yöntemi tercih edilebilir.Öde ve Kullan yöntemi ile satın alım işlemi 4 adımda tamamlanmaktadır: <ul><li>1. Satın almak istediğiniz paketi seçin ve sayfanın altındaki 'Ödeme Talebi Oluştur' butonuna basın. Talebinizi onayladığınızda sanal bir fatura oluşturulacak ve fatura numarası sizinle paylaşılacaktır.</li><li>2. Online bankacılık vb. ödeme kanalları aracılığıyla Mesaj Üssünde kullandığınız telefon numarasınız ve Öde ve Kutlan fatura numarnızı sorgulayarak ödemenizi yapın. Faturanızı ödeyebileceğiniz kanallar için: https://www.turkcell.com.trikurumsaliyardimıhattinizıfaturali/faturami-hangi-kanallardan-odeyebilirim. </li><li>3. Ödemenizi yaptıktan sonra, ödeme bilginiz ortalama 2 iş gün içinde bankanız tarafından bize otomatik olarak iletilecektir. </li><li> 4. Ödeme bilginiz bize ulaştığında Mesaj Üssü paketiniz otomatik olarak hesabınıza yüklenecek ve satın alimin tamamlandığına SMS ile bilgilendirileceksiniz.</li></ul> <p>Öde ve Kullan ile ilgili önemli bilgiler: Öde ve Kullan ile oluşturduğunuz faturanın ödemesini gerçekleştirdikten sonra, Mesaj Üssü paketinizin hesabınıza yüklenmesi için ödeme onayının bankanızdan bize ulaşması gerekmektedir. Bu süreç ortalama 2 iş günü içinde tamamlanmakla birlikte tatil günlerinde süre uzayabilmektedir. Bu sırada satın alım talebiniz Mesaj Üssü platformunda banka mutabakatı bekleniyor statüsünde gözükecektir. Öde ve Kullan ile oluşturulan sanal faturanın son ödeme tarihine kadar ödenmemesi durumunda, bu fatura otomatik olarak iptal olacak ve size herhangi bir mali yükümlülük doğurmayacaktır. Öde ve Kullan ile aynı anda yalnızca 1 paket satın alma talebi oluşturabilirsiniz. Bir satın alma talebi sonuçlanmadan yeni bir satın alma talebi oluşturamazsınız. Öde ve Kullan yöntemi ile satın alım işleminiz tamamlandığında; Hattınızın dönem sonu faturasında satın aldığınız Mesaj Üssü paketi ve önden yapmış olduğunuz ödeme bilgisi birer kalem olarak gözükecektir.</p>",
  },
  {
    header: 'Kredi kartıyla alınan paketler için fatura talep edilebilir miyim?    ',
    content:
      'Mesaj Üssü’nde kredi kartı ile yapılan satın alımlarda, satın alımı takip eden ayın başında Turkcell sistemlerinde “Hazır Kart Faturası” veya “Dijital TL Yükleme Faturası”  isimde bir fatura oluşur. Müşterinin KMT’si varsa KMT’si, yoksa destek servis faturaya ulaşabilir  “Evrak Arşiv”  alanından faturaya ulaşılabilir.',
  }
];
const SubjectList = ['Konu 1', 'Konu 2', 'Konu 3', 'Konu 4', 'Konu 5'];

const SupportCreditPurchase = () => {
  const [modalSendUs, setModalSendUs] = useState(false);
  const { isTabletBig } = useContext(DimensionsContext);
  const [form] = Form.useForm();

  let history = useHistory();

  function onChangeTabs(key) {
    if (key == 1) {
      history.push('./CreditPurchaseHelp');
    } else if (key == 2) {
      history.push('./MessagesHelp');
    } else if (key == 3) {
      history.push('./ReportsHelp');
    } else if (key == 4) {
      history.push('./AccountsHelp');
    }
  }

  return (
    <Layout>
      <div className="profile-page support">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Yardım</h1>
          </div>
          <div className="content-wrapper">
            {isTabletBig ? (
              <div className="profile-page__menu sub-groups">
                <h2 className="box__title">Yardım Konuları</h2>
                <ul>
                  <li>
                    <NavLink
                      to="./CreditPurchaseHelp"
                      classname="active"
                      activeClassName="active"
                    >
                      <span>Kredi Satın Alımı</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="./MessagesHelp"
                      activeClassName="active"
                    >
                      <span>Gönderim İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./ReportsHelp" activeClassName="active">
                      <span>Raporlar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./AccountsHelp" activeClassName="active">
                      <span>Şirket ve Hesaplar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                </ul>
                <div className="write-us">
                  <span>Sorularınıza yanıt alamadınız mı?</span>
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => setModalSendUs(true)}
                  >
                    Bize Yazın
                  </Button>
                </div>
              </div>
            ) : (
              <Tabs
                defaultActiveKey="1"
                onChange={onChangeTabs}
                renderTabBar={(props, Item) => {
                  return <MobileTabBar props={props} item={Item} />;
                }}
              >
                <TabPane tab="Kredi Satın Alımı" key="1"></TabPane>
                <TabPane tab="Gönderim İşlemleri" key="2"></TabPane>
                <TabPane tab="Raporlar" key="3"></TabPane>
                <TabPane tab="Şirket ve Hesaplar" key="4"></TabPane>
              </Tabs>
            )}
            <div className="profile-page__content">
              <Accordion list={AccordionList} />
            </div>
            {!isTabletBig ? (
              <div className="write-us">
                <span>Sorularınıza yanıt alamadınız mı?</span>
                <Button
                  type="primary"
                  shape="round"
                  onClick={() => setModalSendUs(true)}
                >
                  Bize Yazın
                </Button>
              </div>
            ) : null}
          </div>
          {modalSendUs &&  (
      <ContactUs visible={modalSendUs} onClose={e=> setModalSendUs(false)}  onOpen={e=> setModalSendUs(true)}  />)}
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default SupportCreditPurchase;
